import { cn } from "@/shared/utils/cn";
import React from "react";

export interface TextareaProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

const Textarea = React.forwardRef<any, any>(({ className, ...props }, ref) => {
  return (
    <div>
      <textarea
        ref={ref}
        rows={4}
        className={cn(
          "max-w-full rounded-[0.5rem] border border-[rgba(0,0,0,0.2)] p-2 shadow-[0_2px_8px_#999] outline-none transition-all focus:shadow-[0_0_0_0.1rem_var(--primary)]",
          className
        )}
        {...props}
      />
      {props?.error && (
        <div className="text-error font-semibold">{props.error}</div>
      )}
    </div>
  );
});

export default Textarea;
